export default __webpack_public_path__ + "static/media/Zone-5-Master-Plan-Type-G.17ddff10.png";